import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";
import { Heading } from "src/components/base/heading";
import { Text } from "src/components/base/text";

/**
 * Error page for outdated oidc logins
 *
 * @returns JSX
 */
function RouteComponent() {
    const [t] = useTranslation("static");

    return (
        <div className={"flex flex-col items-center justify-center gap-4"}>
            <Heading>{t("heading.outdated")}</Heading>
            <Text>{t("description.outdated")}</Text>
        </div>
    );
}

export const Route = createFileRoute("/_static/s/login/outdated")({
    component: RouteComponent,
});
